import Vue                from 'vue'
import VueRouter          from 'vue-router';
import App                from './App.vue'
import VueResource        from 'vue-resource'

import CarBrandSideBar    from './components/SideMenu/CarBrandSideBar.vue'
import CarModelSideBar    from './components/SideMenu/CarModelSideBar.vue'
import CarYearSideBar     from './components/SideMenu/CarYearSideBar.vue'

import AdminMain          from './components/admin/AdminMain.vue'
import BankAdmin          from './components/admin/BankAdmin.vue'
import CarBrandAdmin      from './components/admin/CarBrandAdmin.vue'
import CarModelAdmin      from './components/admin/CarModelAdmin.vue'
import CarForSaleAdmin    from './components/admin/CarForSaleAdmin.vue'
import InquiryAdmin       from './components/admin/InquiryAdmin.vue'

import InquiryCalculator  from './components/InquiryCalculator.vue'
import CarForSaleAdd      from './components/CarForSaleAdd.vue'
import CarForSaleAddPre   from './components/CarForSaleAddPre.vue'
import CarForSaleView     from './components/CarForSaleView.vue'
import CarForSaleAllView  from './components/CarForSaleAllView.vue'
import ImageUpload        from './components/ImageUpload.vue'
import Main               from './components/Main.vue'

import MainNav            from './components/gui/MainNav.vue'
import AdminNav           from './components/gui/AdminNav.vue'

import Generic            from './components/misc/Generic.vue'
import InfoMessage        from './components/misc/InfoMessage.vue'
import Help               from './components/misc/Help.vue'
import Pagination         from './components/misc/Pagination.vue'
import Home               from './components/misc/Home.vue'
import Gallery            from './components/misc/Gallery.vue'

import Login              from './components/membership/Login.vue'
import Register           from './components/membership/Register.vue'
import Logout             from './components/membership/Logout.vue'
import { routes }         from './routes'


Vue.filter('AddCommasToNumber', function(value){
  return (value + "").replace(/\b(\d+)((\.\d+)*)\b/g, function(a, b, c) {
            return (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".") ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,") : b) + c;
        })  
});

Vue.use(VueRouter);

const router = new VueRouter({
  routes:routes,
  mode:'history'
});

router.beforeEach((to, from, next) => {    
    next();
});

Vue.use(VueResource);

console.log('process.env.NODE_ENV:', process.env.NODE_ENV);

if(process.env.NODE_ENV === 'production'){
  Vue.http.options.root = 'https://alanautos.com';
}else if(process.env.NODE_ENV === 'qa'){
  Vue.http.options.root = 'https://alanautosqa.marcosrijo.com';
}else{
  Vue.http.options.root = 'http://localhost:3000';
}

//var rootUrl = 'http://localhost:8080';       //local
//var rootUrl = 'http://168.235.66.193:8081';  //dev
//var rootUrl = 'https://alanautos.com';        //prod path /var/www/html/alanautoprod
//Vue.http.options.root = rootUrl; //prod

Vue.http.interceptors.push((request, next) => {    //si VueResource no quiere mandar los cookie en los request le pone esto    
    request.credentials = true;
    next();
});

Vue.component('CarBrandSideBar'   , CarBrandSideBar);
Vue.component('CarModelSideBar'   , CarModelSideBar);
Vue.component('CarYearSideBar'    , CarYearSideBar);

Vue.component('CarBrandAdmin'     , CarBrandAdmin);
Vue.component('CarModelAdmin'     , CarModelAdmin);
Vue.component('BankAdmin'         , BankAdmin);
Vue.component('InfoMessage'       , InfoMessage);
Vue.component('InquiryCalculator' , InquiryCalculator);
Vue.component('InquiryAdmin'      , InquiryAdmin);
Vue.component('CarForSaleAdd'     , CarForSaleAdd);
Vue.component('CarForSaleAddPre'  , CarForSaleAddPre);
Vue.component('CarForSaleAdmin'   , CarForSaleAdmin);
Vue.component('CarForSaleView'    , CarForSaleView);
Vue.component('CarForSaleAllView' , CarForSaleAllView);
Vue.component('ImageUpload'       , ImageUpload);
Vue.component('MainNav'           , MainNav); 
Vue.component('AdminNav'          , AdminNav); 
Vue.component('Help'              , Help);
Vue.component('Pagination'        , Pagination);
Vue.component('Main'              , Main);
Vue.component('AdminMain'         , AdminMain);
Vue.component('Home'              , Home);
Vue.component('Gallery'           , Gallery);
Vue.component('Login'             , Login);

Vue.component('Register'          , Register);
Vue.component('Generic'           , Generic);
Vue.component('Logout'            , Logout);

export const eventBus = new Vue();

new Vue({
  el: '#app',
  router:router,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js